module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/tutorials-examples-circuit-breaker.json
// module id = 814
// module chunks = 236038608871840